import { render, staticRenderFns } from "./aed-closedDays.vue?vue&type=template&id=8ed5bb8a&"
import script from "./aed-closedDays.vue?vue&type=script&lang=js&"
export * from "./aed-closedDays.vue?vue&type=script&lang=js&"
import style0 from "./aed-closedDays.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports